var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Link',{attrs:{"title":_vm.$t('common.show'),"onClick":_vm.onClick}},[_c('p',{staticClass:"sub"},_vm._l((_vm.summaryItems),function(item){return _c('span',{key:item.label},[_vm._v(" "+_vm._s(item.count)+" "+_vm._s(item.label)+" ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }